import { ArrayInput, SimpleFormIterator } from "react-admin";

import { EmployeeServicePath, TREE } from "utils/constants";

import NodeItem from "components/Administration/Employees/components/NodeItem";

const NodeEmployeeContent = ({ structuralUnitId, setStructuralUnitId }) => {
  return (
    <ArrayInput
      source="nodeEmployees"
      label="Длъжности"
      defaultValue={[{ nodeId: "", positions: [{}] }]}
    >
      <SimpleFormIterator>
        <NodeItem
          source="nodeId"
          name="nodeId"
          label="Структура"
          structuralUnitId={structuralUnitId}
          setStructuralUnitId={setStructuralUnitId}
          reference={`${EmployeeServicePath}${TREE}`}
          allowEmpty
        />
      </SimpleFormIterator>
    </ArrayInput>
  );
};
export default NodeEmployeeContent;
